module.exports = __webpack_public_path__ + "img/weingutloewenstein_6.46be6b7b.jpg";